import React from "react";
import ReactApexChart from "react-apexcharts";
import { PIE_CHART_COLORS } from "config";
import Box from "utils/Box";
import Grid from "utils/Grid";
import withStyles from "utils/withStyles";
import UbuntuTypography from "../common/UbuntuTypography";

const useStyles = (theme) => ({
  innerTypography: {
    fontWeight: "lighter",
    fontSize: "20px",
    marginBottom: 0,
    color: "#646464",
    [theme.breakpoints.down('lg')]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "12px",
    },
  },
  totalCount: {
    marginTop: theme.spacing(2),
    color: "#646464",
    lineHeight: "1px",
    fontWeight: "bold",
    [theme.breakpoints.down('lg')]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "16px",
    },
  },
  inStockTypography: {
    width: 14,
    height: 14,
    marginRight: theme.spacing(1),
    marginTop: 3,
    borderRadius: "25%",
    backgroundColor: PIE_CHART_COLORS.GREEN,
  },
  boxContainer: {
    transform: "translate(-50%, -40%)",
    display: "flex",
    flexDirection: "column",
  },
  divContainer: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(2)} !important`,
    },
  },
  typographyBox: {
    width: 14,
    height: 14,
    marginRight: 5,
    marginTop: 3,
    borderRadius: "25%",
    backgroundColor: PIE_CHART_COLORS.ORANGE,
  },
  typographyBox2: {
    width: 14,
    height: 14,
    marginRight: 5,
    marginTop: 3,
    borderRadius: "25%",
    backgroundColor: PIE_CHART_COLORS.RED,
  },
});
class DonutChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        props.data.in_stock,
        props.data.low_stock,
        props.data.out_of_stock,
      ],
      options: {
        legend: {
          show: false,
          position: "bottom",
          floating: true,
          fontSize: "16px",
          fontFamily: "Ubuntu",
          fontSize: "13px",
          fontWeight: 500,
          labels: {
            colors: "#606C80",
            useSeriesColors: false,
          },
        },
        colors: [
          PIE_CHART_COLORS.GREEN,
          PIE_CHART_COLORS.ORANGE,
          PIE_CHART_COLORS.RED,
        ],
        titleTextStyle: {
          color: "#045298",
          fontSize: 15,
          bold: true,
          fontName: "Ubuntu",
        },
        fill: {
          // type: 'gradient'
        },
        labels: ["In Stock", "Running Low", "Out of Stock"],
        chart: {
          type: "donut",
          width: "100%",
          height: 240,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.round((val * props.data.total) / 100);
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return parseFloat(val).toFixed(2) + "%";
            },
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
            donut: {
              size: "60%",
              labels: {
                show: true,
                name: { show: true, fontSize: "18px", color: "#646464", offsetY: -4 },
                value: { show: true, fontSize: "22px", fontWeight: 700, color: "#646464", offsetY: 6 },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total",
                  color: "#646464",
                  fontSize: "18px",
                  formatter: () => `${props.data.total ?? 0}`,
                },
              },
            },
          },
        },
      },
    };
  }
  render() {
    const { classes } = this.props;
    return (
      <Grid container style={{ marginTop: "8px" }}>
        <Grid xl={8} lg={8} xs={12} md={12}>
          <div id="donut-chart" className={classes.divContainer}>
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="donut"
            />
          </div>
        </Grid>
        <Grid
          xl={4}
          lg={4}
          xs={12}
          md={12}
          
          alignItems={{ xs: "center", lg: "flex-start" }}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            whiteSpace: "nowrap",
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Box display="flex" justifyContent="center" alignItems="flex-start">
              <Box className={classes.inStockTypography} />
              <UbuntuTypography variant="body2">In Stock</UbuntuTypography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="flex-start">
              <Box className={classes.typographyBox} />
              <UbuntuTypography variant="body2">Running Low</UbuntuTypography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="flex-start">
              <Box className={classes.typographyBox2} />
              <UbuntuTypography variant="body2">Out of stock</UbuntuTypography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  }
}
export default withStyles(useStyles)(DonutChart);
